import { render, staticRenderFns } from "./ViewPost.vue?vue&type=template&id=04cd713e&scoped=true&"
import script from "./ViewPost.vue?vue&type=script&lang=js&"
export * from "./ViewPost.vue?vue&type=script&lang=js&"
import style0 from "./ViewPost.vue?vue&type=style&index=0&id=04cd713e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd713e",
  null
  
)

export default component.exports